/* eslint-disable camelcase */
import React from 'react';
import PropTypes from 'prop-types';
import { intlShape, injectIntl } from 'react-intl';
import debounce from 'lodash/debounce';
import isEmpty from 'lodash/isEmpty';
import messages from '../../messages';
import Icon from '../../../components/shared/Icons/Icon';
import SelectTypes from '../../../common/forms/SelectTypes';
import Input from '../../../common/forms/Input';
import AutoCompleteInput from '../../../common/forms/AutoCompleteInput';
import Theme from '../../../themes';
import Button from '../../../common/forms/Button';
import Error from './common/Error';
import { getMinimumCharactersLengthByCountryCode, isValidInput } from '../../../utils/validation';

const { searchPlaceholder, buscar } = messages;
const { borderColor } = Theme.forms.inputs;

const selectStyle = { marginBottom: 15 };
const inputStyle = { padding: '1em', border: `1px solid ${borderColor}` };
const buttonStyle = { padding: '1em', marginTop: '15px' };

class Form extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      type_id: props.typeId || props.typeIdDefault,
      what: props.what || '',
      whatError: false,
      isUserSearch: 1,
    };

    if (typeof this.props.onSearchChanged === 'function') {
      this.onSearchChanged = debounce(this.props.onSearchChanged, 600);
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.typeId !== this.props.typeId) {
      this.setState({
        type_id: nextProps.typeId,
      });
    }
  }

  onSubmit = e => {
    e.preventDefault();
    const { type_id, what, isUserSearch } = this.state;
    const { countryCode } = this.props;
    const minLength = getMinimumCharactersLengthByCountryCode(countryCode);

    if (!isValidInput(what, minLength)) {
      this.setState({ whatError: true });
      return;
    }

    this.props.onSearchSubmit({ type_id, what_d: what, isUserSearch });
  };

  onSelectType = e => {
    const typeId = e.setDefault || e.target.value;
    this.setState({ type_id: parseInt(typeId, 10) });
  };

  onTextType = e => {
    this.setState(
      {
        what: e.target.value || undefined,
        whatError: false,
      },
      () => {
        if (
          typeof this.props.onSearchChanged === 'function' &&
          this.props.hasAutoCompleteFieldsInSearch &&
          !isEmpty(this.state.what)
        ) {
          this.onSearchChanged({ what: this.state.what });
        }
      }
    );
  };

  isNumber = value => typeof value === 'number' && !isNaN(value);

  render() {
    const {
      intl,
      typeId: typeIdFromProps,
      autoCompleteItems,
      hasAutoCompleteFieldsInSearch,
    } = this.props;

    const { type_id: typeId, what, whatError } = this.state;
    let inputElement;

    if (hasAutoCompleteFieldsInSearch) {
      inputElement = (
        <AutoCompleteInput
          field={'what'}
          items={autoCompleteItems}
          onChange={event => this.onTextType(event)}
          onSelect={val => this.setState({ what: val })}
          value={what}
          placeholder={intl.formatMessage(searchPlaceholder)}
          style={inputStyle}
        />
      );
    } else {
      inputElement = (
        <Input
          type="text"
          name="what_d"
          value={what}
          placeholder={intl.formatMessage(searchPlaceholder)}
          onChange={this.onTextType}
          style={inputStyle}
        />
      );
    }

    return (
      <div className="searchBox">
        <form onSubmit={this.onSubmit} action="/q" method="get">
          <input type="hidden" name="page" value="1" />
          <input type="hidden" name="isUserSearch" value="1" />

          {whatError && <Error />}

          {this.isNumber(typeIdFromProps) && (
            <SelectTypes
              size="big"
              selectedOption={typeId}
              onChange={this.onSelectType}
              style={selectStyle}
            />
          )}

          {inputElement}

          <Button
            id={'submit-search-button__home'}
            type="submit"
            icon={<Icon type="search" />}
            title={intl.formatMessage(buscar)}
            color="blue"
            fullWidth
            style={buttonStyle}
          />
        </form>
        <style jsx>
          {`
            .searchBox form {
              padding: 20px;
              margin-bottom: 25px;
            }
          `}
        </style>
      </div>
    );
  }
}

Form.defaultProps = {
  what: null,
  typeId: null,
  typeIdDefault: 1,
  onSearchChanged: null,
  hasAutoCompleteFieldsInSearch: false,
  autoCompleteItems: [],
};

Form.propTypes = {
  countryCode: PropTypes.string.isRequired,
  onSearchSubmit: PropTypes.func.isRequired,
  onSearchChanged: PropTypes.func,
  what: PropTypes.string,
  typeId: PropTypes.number,
  typeIdDefault: PropTypes.number,
  intl: intlShape.isRequired,
  hasAutoCompleteFieldsInSearch: PropTypes.bool,
  autoCompleteItems: PropTypes.array,
};

export default injectIntl(Form);



// WEBPACK FOOTER //
// ./app/Index/components/Forms/Form.js